import { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { MdLocationOn } from 'react-icons/md';
import { Paper } from '@material-ui/core';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import NumberFormat from 'react-number-format';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import useStyles from '../styles';
import currencySymbol from '../../../../../helpers/currencySymbol';
import TourDetails from '../../TourDetails';

const TourItineraryContent = ({
  itinerary, doHaveBorderAround, wrapperClassName, doShowPrice, tripId, tripRoomSearchInput,
}) => {
  const router = useRouter();
  const classes = useStyles();
  const isBrochurePage = router.pathname.indexOf('brochure') > -1;
  const { travelAgency = {} } = useSelector((state) => state.user);
  const brochureSettings = travelAgency?.settings?.brochureSettings || {};
  const doExpandItineraryDetailsByDefault = !!brochureSettings?.doExpandItineraryDetailsByDefault
  && isBrochurePage;
  const [isDetailsOpen, setIsDetailsOpen] = useState(doExpandItineraryDetailsByDefault);

  // eslint-disable-next-line no-unused-vars
  const tripRoomSearchInputt = tripRoomSearchInput;

  const handleDetailsClick = () => {
    setIsDetailsOpen((v) => !v);
  };

  const classNames = {
    imgContainerClass: clsx(
      'overflow-hidden h-40 w-40 align-middle md:flex-shrink-0',
    ),
    tagsClass: clsx(
      'text-gray-500',
    ),
    dropdownButtonClass: clsx(
      'text-theme mt-1 focus:outline-none',
    ),
  };

  return (
    <div
      className={clsx('p-5 m-1 grid grid-cols-4 gap-2 sm:gap-3', wrapperClassName, { 'border-2': doHaveBorderAround })}
    >
      <div className="col-span-4 md:col-span-3 md:flex gap-x-3">
        {(itinerary && itinerary.image)
          ? (
            <img
              src={itinerary.image}
              alt={itinerary.image}
              className="email-img md:h-40 w-full md:w-auto"
            />
          ) : (
            <Paper square classes={classes} className="email-hidden-field flex-shrink-0 md:h-40 md:w-40">
              No photo
            </Paper>
          )}
        <div className="p-2 md:p-0">
          <div className="font-bold">
            {itinerary.name}
          </div>
          {itinerary.destination && (
            <div className="text-sm -ml-1 mt-1">
              <MdLocationOn size="20" className="inline-block -mt-1" />
              {itinerary.destination}
            </div>
          )}
          <div className={classNames.tagsClass}>
            {itinerary.description}
          </div>
        </div>
      </div>

      <div className="flex flex-col justify-between items-end col-span-4 md:col-span-1">
        <div className="text-right md:inline-block grid grid-cols-2 w-full md:w-auto">
          {doShowPrice && (
            <div className={clsx('font-bold leading-tight text-left md:text-right self-center', { 'text-sm': '' })}>
              from
              <NumberFormat value={itinerary.rates[0].price} displayType="text" thousandSeparator prefix={` ${currencySymbol(itinerary.cost.currencyCode)}`} fixedDecimalScale decimalScale={2} />
            </div>
          )}
          <div className={clsx({ 'col-start-2': !doShowPrice }, 'col-span-2 md:col-span-1')}>
            <button onClick={handleDetailsClick} type="button" className={`${classNames.dropdownButtonClass} email-hidden-field`}>
              {!isDetailsOpen
                && (
                  <>
                    <span>View details </span>
                    <FaChevronDown className="inline-block" />
                  </>
                )}
              {isDetailsOpen
                && (
                  <>
                    <span>Hide details </span>
                    <FaChevronUp className="inline-block" />
                  </>
                )}
            </button>
          </div>
        </div>
      </div>
      <div className="col-span-4">
        {isDetailsOpen && <TourDetails itinerary={itinerary} tripId={tripId} />}
      </div>
    </div>
  );
};

TourItineraryContent.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  tripId: PropTypes.string,
  doHaveBorderAround: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  doShowPrice: PropTypes.bool,
  tripRoomSearchInput: PropTypes.arrayOf(PropTypes.shape()),
};

TourItineraryContent.defaultProps = {
  tripId: '',
  doHaveBorderAround: true,
  wrapperClassName: 'rounded-lg',
  doShowPrice: true,
  tripRoomSearchInput: undefined,
};

export default TourItineraryContent;
